import { defineComponent, openBlock, createElementBlock, normalizeStyle, createElementVNode, createCommentVNode } from 'vue';
import _export_sfc from '../_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "TwoClose",
  props: {
    gradient: {
      type: Boolean
    },
    borderWidth: {
      type: [Number, String],
      default: "1.5"
    },
    opacity: {
      type: [Number, String],
      default: "0.15"
    },
    startColor: {
      type: String,
      default: ""
    },
    iconId: [String, Number]
  }
});
const _hoisted_1 = { key: 0 };
const _hoisted_2 = ["id"];
const _hoisted_3 = /* @__PURE__ */ createElementVNode("stop", {
  "stop-color": "currentColor",
  offset: "100%"
}, null, -1);
const _hoisted_4 = ["stroke"];
const _hoisted_5 = /* @__PURE__ */ createElementVNode("path", { d: "M4.70064453,4.70064453 L19.6339779,19.6339779 M4.70064453,19.6339779 L19.6339779,4.70064453" }, null, -1);
const _hoisted_6 = [
  _hoisted_5
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    "aria-labelledby": "Close",
    role: "presentation",
    class: "icon-twotones",
    style: normalizeStyle(`--stroke-width: ${_ctx.borderWidth};--fill-opacity: ${_ctx.opacity};`)
  }, [
    _ctx.gradient ? (openBlock(), createElementBlock("defs", _hoisted_1, [
      createElementVNode("linearGradient", {
        id: `${_ctx.iconId}`,
        x1: "50%",
        y1: "0%",
        x2: "50%",
        y2: "100%",
        gradientUnits: "userSpaceOnUse"
      }, [
        createElementVNode("stop", {
          style: normalizeStyle({
            stopColor: _ctx.startColor ? _ctx.startColor : "var(--icon-start-color)"
          }),
          offset: "0%"
        }, null, 4),
        _hoisted_3
      ], 8, _hoisted_2)
    ])) : createCommentVNode("v-if", true),
    createElementVNode("g", {
      stroke: _ctx.gradient ? "url(#" + _ctx.iconId + ")" : "currentColor",
      style: { "fill": "currentColor", "stroke-width": "var(--stroke-width)", "fill-opacity": "var(--fill-opacity)", "stroke-linecap": "round", "stroke-linejoin": "round", "fill-rule": "evenodd" }
    }, _hoisted_6, 8, _hoisted_4)
  ], 4);
}
var Close = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { Close as default };
